import { Component, NgModule, OnInit, Pipe } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Printer, PrintOptions } from '@ionic-native/printer/ngx';
import { ToastService } from 'src/app/core/toast.service';
import { ApiConsumidorService } from 'src/app/dao/api-consumidor.service';
import { ApiEntregadorService } from 'src/app/dao/api_entregador.service';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Motoboy } from 'src/app/model/motoboy';
import { Ordem } from 'src/app/model/ordem';
import { Pedido } from 'src/app/model/pedido';
import { SoundService } from 'src/app/shared/SoundService';


@Component({
  selector: 'app-gerenciar-pedidos',
  templateUrl: './gerenciar-pedidos.page.html',
  styleUrls: ['./gerenciar-pedidos.page.scss'],
})


export class GerenciarPedidosPage implements OnInit {

  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  pedidos: Pedido[] = [];
  pedido: Pedido;
  inicio = '';
  fim = '';
  user: string;
  pass: string;
  idCategoria;
  data1: string;
  dataAtual;
  data2: string;
  tipoPedido;
  dataAtuaFormatada;
  status = [];

  aberto;
  emissao;
  producao;
  entrega;
  finalizado;
  cancelado;
  status_selecionado = 1;
  status_string = "Abertos";
  loading = false;
  dataPesquisada = new Date().toISOString().split('T')[0];

  quantidade = 0;

  contadorPedidosPagina = 0;

  telefoneEnviar;
  estilo;
  rodarReload;
  mobileBol;

  pedidoDialog: boolean;
  displayModal = false;
  displayModal2 = false;
  displayModal3 = false;
  pedidoSelecionado: Pedido;

  entregadorSelecionado;
  consumidorPedidoSelecionado;


  entregadores: Motoboy[] = [];

  idPedidoSelecionado;

  ordens;

  ordemSelecionada: Ordem;


  cupom: any;
  cupom64;


  tokenPedidoSelecionado = "";
  dtPedidoSelecionado = "";


  private cacheResultados: { [pedidoId: string]: boolean } = {};


  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    private pedidoapi: PedidoService,
    private global: GlobalService,
    private printer: Printer,
    private consumidorApi: ApiConsumidorService,
    private apiUnidade: UnidadeApiService,
    private entregadorService: ApiEntregadorService,
    private soundService: SoundService) { }


  ngOnInit() {
    this.estilo = {
      "color": "red",
      "font-weight": "bold"
    }
    this.dataAtual = new Date();
    this.dataAtuaFormatada = this.dataAtual.toISOString().split('T')[0];
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadStatus();

    const idParam = this.route.snapshot.paramMap.get('tipo');
    if (idParam) {

      this.tipoPedido = idParam;
      // tslint:disable-next-line: radix
      this.idCategoria = parseInt(idParam);
      // tslint:disable-next-line: radix
    }

    this.loadPedidos(idParam);
    this.loadEntregadores();
    
  }


  async contaPedidos(numPedidos){

    const unidade = await this.apiUnidade.getAtual();
    console.log(unidade.alerta_pedido);
    if(unidade.alerta_pedido){
    if(numPedidos > this.contadorPedidosPagina){
      console.log("MANDA O SONORO");
      this.soundService.playSound(); // Aqui você está chamando o método playSound do serviço SoundService
      this.contadorPedidosPagina = numPedidos;
    }else{
      console.log("Faz nada");
      //this.soundService.playSound();
      this.contadorPedidosPagina = numPedidos;
    }
  }
  }

  loadEntregadores() {
    return this.entregadorService.listarTodas()
      .then(res => {
        this.entregadores = res.map(c => {
          return ({ label: c.nome, value: c.id });
          // tslint:disable-next-line: align
        });
        this.entregadores.splice(0,0,{nome: "Nenhum", id: "0"})

        console.log(this.entregadores);
      })
      
      .catch(erro => {
        this.toast.showError('Erro ao carregar Entregadores!');
      });

      
  }

  ionViewWillEnter() {
    this.mobileBol = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.rodarReload = true;
    this.data1 = this.dataAtuaFormatada;
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadStatus();
    if (this.dataPesquisada != null || this.dataPesquisada != '') {
      this.dataPesquisa2(this.dataPesquisada);
    }
    this.reloadFunction();
    this.loadEntregadores();
  }

  ionViewDidLeave(){
    this.rodarReload = false;
  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }



  abrirModalLink(pedido: Pedido) {
    this.displayModal = true;
    this.pedidoSelecionado = pedido;
    this.consumidorPedidoSelecionado = pedido.id_consumidor;
    this.entregadorSelecionado = pedido.motoboy;
    console.log(pedido);
  }

  salvarPedido(){
    this.displayModal = false;
    if(this.entregadorSelecionado <= 0){

    }else{
      this.pedidoSelecionado.motoboy = this.entregadorSelecionado;
      this.pedidoSelecionado.status = 4+"";
      this.pedidoapi.editarStatuseEntregador(this.pedidoSelecionado);
    }
    this.reloadFunction();
  }


  

  esconderModalLink(){
    this.displayModal = false;
    //this.atendente.tempo_uso_link = "3600";
   // console.log("chamou");
    //this.campoLink = '';
    //this.linkwhatsapp = '';
    //this.showdivLink = false;
    //document.getElementById('divLink').style.display = 'hidden';
  }


  esconderModalLink2(){
    this.displayModal2 = false;
  }

  esconderModalLink3(){
    this.displayModal3 = false;
  }


  async saveatendente() {
    /*this.submitted = true;

    if (this.atendente.nome.trim()) {
      if (this.atendente.id) {
        this.atendentes[this.findIndexById(this.atendente.id)] = this.atendente;
        this.atendente.nome = this.atendente.nome.replace(/\s/gi, '_');
        this.atendenteService.atualizar(this.atendente);
        this.toast.showSucess('Atendente Atualizado com Sucesso!');
      } else {
        // tslint:disable-next-line: radix
        this.atendente.nome = this.atendente.nome.replace(/\s/gi, '_');
        const result = await this.atendenteService.adicionar(this.atendente);
        this.atendentes.push(result);
        this.toast.showSucess('Atendente Cadastrado com Sucesso!');
      }

      this.atendentes = [...this.atendentes];
      this.atendenteDialog = false;
      this.atendente = {};
    }*/
  }



  reloadFunc(){
    this.loading = true;
    const dataAux = this.data1.replace(/\-/gi, '');
    this.data2 = this.data1.replace(/\-/gi, '');

    this.data2 += '235959';
    const dataAux1 = dataAux + '000000';

    this.pedidoapi.getDataeParamGerenciar(dataAux1, this.data2, this.status_selecionado, this.tipoPedido).then(res => {
      this.pedidos = res;
      console.log(this.pedidos);
      this.quantidade = res.length;
      console.log("Rodou Reload Manual");
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }
      this.contaPedidos(this.quantidade);

      this.loading = false;
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }
    

  async reloadFunction() {
    if(this.rodarReload){
    await this.delay(30000);
    const dataAux = this.data1.replace(/\-/gi, '');
    this.data2 = this.data1.replace(/\-/gi, '');

    this.data2 += '235959';
    const dataAux1 = dataAux + '000000';

    this.pedidoapi.getDataeParamGerenciar(dataAux1, this.data2, this.status_selecionado, this.tipoPedido).then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      console.log(this.pedidos);
      console.log("Rodou Reload");
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }
        this.contaPedidos(this.quantidade);
      this.loading = false;
      this.reloadFunction();
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }
  }


  async enviaWhats(pedido, stts) {
    console.log(pedido);
    const consumidor_id = pedido.consumidor_id;
    const nomeCliente = pedido.id_consumidor;
    this.telefoneEnviar = await this.consumidorApi.getTelById(consumidor_id);

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const celFormatado = this.telefoneEnviar.replace(/[)(-]/g, '').split(' ').join('');
    const unidade = await this.apiUnidade.getAtual();
    let mensagem;
    console.log(stts);
    switch (stts) {
      case 1:
        mensagem = unidade.msg_consumidor;
        break;
      case 2:
        mensagem = unidade.msg_consumidor_emissao;
        break;
      case 3:
        mensagem = unidade.msg_consumidor_producao;
        break;
      case 4:
        mensagem = unidade.msg_consumidor_entrega;
        break;
      default:
        mensagem = unidade.msg_consumidor;
    }


    if (celFormatado.length === 10 || celFormatado.length === 11) {
      if (isMobile) {
        window.open('https://api.whatsapp.com/send?1=pt_BR&phone=55' + celFormatado + '&text= ' + mensagem + '');
      } else {
        window.open('https://web.whatsapp.com/send?phone=55' + celFormatado + '&text= ' + mensagem + '');
      }
    } else {
      this.toast.showError('Não foi possível entrar em contato: Telefone Inválido!');
    }
  }


  async loadPedidos(idParam) {
    this.loading = true;
    const dataAtual = this.dataAtuaFormatada.replace(/\-/gi, '');

    const dataaux1 = dataAtual + '000000';
    const dataaux2 = dataAtual + '235959';
    this.pedidoapi.GetPadraoGerenciador(dataaux1, dataaux2, idParam).then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;

      }
      this.loading = false;
      console.log(this.pedidos);
      //this.toast.showSucess('Histórico obtido com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      //this.toast.showError('Erro ao obter Histórico');
    });

  }

  



  alterarFiltro(param) {
    this.loading = true;
    switch (param) {
      case 1: this.status_string = "Abertos";
        break;

      case 2: this.status_string = "Em Emissão";
        break;

      case 3: this.status_string = "Em Produção";
        break;

      case 4: this.status_string = "Em Entrega";
        break;

      case 5: this.status_string = "Finalizados";
        break;

      case 6: this.status_string = "Cancelados";
        break;
    }

    this.status_selecionado = param;

    const dataAux = this.data1.replace(/\-/gi, '');
    this.data2 = this.data1.replace(/\-/gi, '');

    this.data2 += '235959';
    const dataAux1 = dataAux + '000000';

    this.pedidoapi.getDataeParamGerenciar(dataAux1, this.data2, this.status_selecionado, this.tipoPedido).then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }

      this.contaPedidos(this.quantidade);
      this.loading = false;
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }


  async loadStatus() {
    this.pedidoapi.getStatus().then(res => {
      this.status = res;
      for (let index = 0; index < this.status.length; index++) {
        const element = this.status[index];

        if (element.id === 1) {
          this.aberto = true;
        }

        if (element.id === 2) {
          this.emissao = true;
        }

        if (element.id === 3) {
          this.producao = true;
        }

        if (element.id === 4) {
          this.entrega = true;
        }

        if (element.id === 5) {
          this.finalizado = true;
        }

        if (element.id === 6) {
          this.cancelado = true;
        }

      }


    }).catch(async err => {
      console.log('err', err);
      //this.toast.showError('Erro ao obter Histórico');
    });
  }

  dataPesquisa($event: any) {
    this.loading = true;
    const value = $event.target.value;

    this.dataPesquisada = value;

    const dataAux = value.replace(/\-/gi, '');
    this.data2 = value.replace(/\-/gi, '');


    this.data2 += '235959';
    const dataAux1 = dataAux + '000000';

    this.pedidoapi.getDataeParamGerenciar(dataAux1, this.data2, this.status_selecionado, this.tipoPedido).then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }
      this.loading = false;
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }




  async dataPesquisa2(data) {
    this.loading = true;
    const value = data;

    this.data1 = this.dataPesquisada;

    const dataAux = value.replace(/\-/gi, '');
    this.data2 = value.replace(/\-/gi, '');

    this.data2 += '235959';
    const dataAux1 = dataAux + '000000';

    this.pedidoapi.getDataeParamGerenciar(dataAux1, this.data2, this.status_selecionado, this.tipoPedido).then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }
      this.loading = false;
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }

  passarStatus(pedido: Pedido) {
    this.loading = true;
    for (let index = 0; index < this.status.length; index++) {
      const element = this.status[index];

      if (pedido.status['id'] === element.id) {
        this.pedidoapi.mudarStatus(pedido, this.status[index + 1].id).then(res => {
          console.log(res[1]);
          if(res[1] == false || res[1] == 0){
            this.toast.showError('Erro ao enviar Notificação');
          }
          this.alterarFiltro(this.status_selecionado);
          this.loading = false;
        }).catch(async err => {
          console.log('err', err);
          this.loading = false;
        });
      }
    }
  }

  voltarStatus(pedido: Pedido) {
    this.loading = true;
    for (let index = 0; index < this.status.length; index++) {
      const element = this.status[index];
      if (pedido.status['id'] === element.id) {
        if (pedido.status['id'] === 1) {
          this.cancelarPedido(pedido);
        } else {
          this.pedidoapi.mudarStatus(pedido, this.status[index - 1].id).then(res => {
            if(res[1] == false || res[1] == 0){
              this.toast.showError('Erro ao enviar Notificação');
            }
            this.alterarFiltro(this.status_selecionado);
            this.loading = false;
          }).catch(async err => {
            console.log('err', err);
            this.loading = false;
          });
        }
      }

    }
    this.loading = false;
  }


  finalizarPedido(pedido: Pedido) {
    this.loading = true;
    for (let index = 0; index < this.status.length; index++) {
      const element = this.status[index];

      if (pedido.status['id'] === element.id) {
        if (pedido.status['id'] === 1) {


          this.pedidoapi.mudarStatus(pedido, 5).then(res => {
            this.alterarFiltro(this.status_selecionado);
            this.loading = false;
          }).catch(async err => {
            console.log('err', err);
            this.loading = false;
          });
        } else {
          this.cancelarPedido(pedido);
        }
      }
    }

  }




  cancelarPedido(pedido: Pedido) {
    this.loading = true;
    for (let index = 0; index < this.status.length; index++) {
      const element = this.status[index];

      if (pedido.status['id'] === element.id) {
        this.pedidoapi.mudarStatus(pedido, 6).then(res => {
          this.alterarFiltro(this.status_selecionado);
          this.loading = false;
        }).catch(async err => {
          console.log('err', err);
          this.loading = false;
        });
      }

    }

  }




  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    this.loadPedidos(this.tipoPedido);
  }

  async doSearchBarChange($event: any) {
    const value = $event.target.value;
    this.pedidos = await this.pedidoapi.GetByNome(value);
  }
  print() {
    // tslint:disable-next-line: prefer-const
    let options: PrintOptions = {
      name: 'MyDocument',
      duplex: true,
      orientation: 'landscape',
      monochrome: true
    };


    this.printer.print().then(res => {
    }).catch(async err => {
      console.log('err', err);
    });


  }



  async listarOrdens(pedido){
    this.ordens = await this.pedidoapi.getOrdensByPedido(pedido.id);
    this.tokenPedidoSelecionado = pedido.token;
    this.dtPedidoSelecionado = pedido.data;
    this.displayModal2 = true;
  }



  async viewOrdem(id: any) {
    console.log(id);
    this.ordemSelecionada = await this.pedidoapi.getOrdem(id);
    this.displayModal3 = true;
    if (this.global.impressao_tamanho == "0") {
      this.cupom = this.splitFunc(this.b64DecodeUnicode(this.ordemSelecionada.cupom));
      this.cupom64 = this.ordemSelecionada.cupom;
    } else {
      this.cupom = this.splitFunc(this.b64DecodeUnicode(this.ordemSelecionada.cupom_reduzido));
      this.cupom64 = this.ordemSelecionada.cupom_reduzido;
    }
  }

  b64DecodeUnicode(str: any) {
    // tslint:disable-next-line: only-arrow-functions
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  splitFunc(cupomRecebido) {
    const lines = cupomRecebido.split("%0A");
    this.cupom = '';
    for (let index = 0; index < lines.length; index++) {
      const element = lines[index];
      this.cupom += element + '<br>';
    }
    console.log(lines);
    return this.cupom;
  }


  printOrdem() {
    document.getElementById('divbtn').style.display = 'none';
    if (this.global.impressao_tipo == "pdf" || this.global.impressao_tipo == " " || !this.global.impressao_tipo || this.global.impressao_tipo.length === 0 ) {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        // tslint:disable-next-line: prefer-const
        let options: PrintOptions = {
          name: 'MyDocument',
          duplex: true,
          orientation: 'landscape',
          monochrome: true
        };
        this.printer.print().then(async res => {
          await this.delay(4000);
          document.getElementById('divbtn').style.display = 'block';

        }).catch(async err => {
          document.getElementById('divbtn').style.display = 'block';
          console.log('err', err);
        });
      } else {
        window.print();
        document.getElementById('divbtn').style.display = 'block';
      }
    } else {
      window.open('techsprinter://ticket?value=' + this.cupom64);
      /*
      let headers = new HttpHeaders();
      const auth = btoa(this.global.user + ':' + this.global.pass);
      headers = headers.set('Authorization', 'Basic ' + auth);
      this.http.get('techsprinter://ticket?value=' + this.cupom64, {}).subscribe((val) => {
        console.log(val);
      });
      */
      document.getElementById('divbtn').style.display = 'block';
    }
  }

  async reImprimirOrdem() {
    try {
      console.log(this.ordemSelecionada);
      const result = await this.pedidoapi.setOrdemNaoImpressaPorId(this.ordemSelecionada.id);
      console.log(result);
      this.toast.showSucess('Pedido reimpresso com sucesso');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar reimprimir o Pedido');
      console.log(error);
    }
  }



  async reImprimirOrdemSelecionada(ordemId) {
    try {
      console.log(ordemId);
      const result = await this.pedidoapi.setOrdemNaoImpressaPorId(ordemId);
      console.log(result);
      this.toast.showSucess('Pedido reimpresso com sucesso');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar reimprimir o Pedido');
      console.log(error);
    }
  }



  async reimprimirPedido(pedido: Pedido) {
    //const result2 = await this.apipedido.getNaoImpressoJava();
    //console.log(result2);
    try {
      console.log(pedido);
      const result = await this.pedidoapi.setNaoImpresso(pedido.id);
      console.log(result);
      if(result == ""){
        let plataforma = window.location.hostname.replace('www.','');
        let dominioAUx = this.global.loja;

        if(pedido.consumidor_id == null || pedido.consumidor_id == ""){
          pedido.id_consumidor = null;
        }

        let ordens = await this.pedidoapi.getOrdens(pedido.token);
        let ordensAux = JSON.stringify(ordens);

        let pedidoAux = JSON.stringify(pedido);

        let json = '{' +
              ' "pedido":'+pedidoAux+' ,' +
              ' "prefixo":"'+dominioAUx+'",' +
              ' "ordens":'+ordensAux+',' +
              ' "plataforma":"'+plataforma+'"}';

        const resultJava = this.pedidoapi.inserirPedidoJava(json);
        console.log(resultJava);
      }
      this.toast.showSucess('Pedido reimpresso com sucesso');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar reimprimir o Pedido');
      console.log(error);
    }

  }



}
